import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface LockedStopOverlayProps {
  isHebrew: boolean;
  onPurchaseClick: () => void;
}

export const LockedStopOverlay: React.FC<LockedStopOverlayProps> = ({
  isHebrew,
  onPurchaseClick
}) => {
  const { t } = useTranslation();

  return (
    <div
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        zIndex: 10,
        background: 'rgba(255,255,255,0.6)',
        cursor: 'pointer'
      }}
      aria-label={t('accessibility.locked_stop') as string}
      onClick={onPurchaseClick}
    >
      <Button
        disableElevation
        disableRipple
        sx={{
          direction: isHebrew ? 'ltr' : 'rtl',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          px: 3,
          py: 1.25,
          minHeight: '44px',
          height: '44px',
          borderRadius: '22px',
          backgroundColor: '#063573',
          color: '#fff',
          border: 'none',
          boxShadow: 'none',
          textTransform: 'none',
          fontWeight: 500,
          fontSize: 16,
          gap: 1.5,
          transition: 'background-color 150ms ease, transform 120ms ease',
          '&:hover': {
            backgroundColor: 'rgba(50,50,50,0.95)',
            transform: 'translateY(-1px)',
            opacity: 0.9
          }
        }}
      >
        <Typography sx={{ color: 'inherit', mr: 1 }}>
          {t('purchase_modal.locked_title')}
        </Typography>
        <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
          <i className="fa-solid fa-bag-shopping" aria-hidden="true" />
        </Box>
      </Button>
    </div>
  );
};
